import React from 'react'

const Card = ({ 
  children, 
  className = '', 
  variant = 'default',
  padding = 'default',
  hover = true,
  ...props 
}) => {
  const baseClasses = 'bg-white rounded-xl shadow-lg transition-all duration-300'
  
  const variants = {
    default: 'border border-gray-100',
    elevated: 'shadow-xl',
    bordered: 'border-2 border-gardenia-gold/30',
    gradient: 'bg-gradient-to-br from-white to-gardenia-gold/10'
  }
  
  const paddings = {
    none: '',
    sm: 'p-4',
    default: 'p-6',
    lg: 'p-8',
    xl: 'p-10'
  }
  
  const hoverEffect = hover ? 'hover:shadow-xl hover:-translate-y-1' : ''
  
  const classes = `${baseClasses} ${variants[variant]} ${paddings[padding]} ${hoverEffect} ${className}`
  
  return (
    <div className={classes} {...props}>
      {children}
    </div>
  )
}

// Componentes adicionales para Card
const CardHeader = ({ children, className = '' }) => (
  <div className={`mb-4 ${className}`}>
    {children}
  </div>
)

const CardTitle = ({ children, className = '' }) => (
  <h3 className={`text-xl font-bold text-gardenia-dark mb-2 ${className}`}>
    {children}
  </h3>
)

const CardSubtitle = ({ children, className = '' }) => (
  <h4 className={`text-lg font-semibold text-gardenia-red mb-2 ${className}`}>
    {children}
  </h4>
)

const CardContent = ({ children, className = '' }) => (
  <div className={`text-gray-600 leading-relaxed ${className}`}>
    {children}
  </div>
)

const CardFooter = ({ children, className = '' }) => (
  <div className={`mt-6 pt-4 border-t border-gray-100 ${className}`}>
    {children}
  </div>
)

const CardImage = ({ src, alt, className = '' }) => (
  <div className={`mb-4 overflow-hidden rounded-lg ${className}`}>
    <img 
      src={src} 
      alt={alt} 
      className="w-full h-48 object-cover transition-transform duration-300 hover:scale-105"
    />
  </div>
)

// Exportar componentes
Card.Header = CardHeader
Card.Title = CardTitle
Card.Subtitle = CardSubtitle
Card.Content = CardContent
Card.Footer = CardFooter
Card.Image = CardImage

export default Card